import { CandidatePayment } from "../interfaces/candidatePayment";
import { fetchWithAuth } from "./fetchWithAuth";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

export const processPaymentIntent = async (
  amount: number,
  paymentID: number,
  candidateEmail: string,
): Promise<any> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const payload = {
    amount,
    paymentID,
    candidateEmail,
  };

  const response = await fetch(
    `${apiBaseUrl}/api/Payment/CreatePaymentIntent`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to create PaymentIntent");
  }

  return response.json();
};

export const createCandidatePayment = async (
  payment: CandidatePayment,
): Promise<CandidatePayment> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetch(
    `${apiBaseUrl}/api/Payment/CreateCandidatePayment`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payment),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to create candidate payment.");
  }
  return response.json();
};

export const createCandidatePaymentSuran = async (
  payment: CandidatePayment,
): Promise<CandidatePayment> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const response = await fetch(
    `${apiBaseUrl}/api/Payment/CreateCandidatePaymentSuran`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payment),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to create candidate payment.");
  }
  return response.json();
};

export const updateCandidatePayment = async (
  payment: CandidatePayment,
): Promise<void> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined.");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated.");
  }

  try {
    const response = await fetchWithAuth(
      `${apiBaseUrl}/api/Payment/UpdateCandidatePayment`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payment),
      },
    );

    if (!response.ok) {
      throw new Error("Failed to update the candidate payment.");
    }
  } catch (error) {
    console.error("Error updating candidate payment:", error);
    throw error;
  }
};

export const updateCandidatePaymentSuran = async (
  payment: CandidatePayment,
): Promise<void> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined.");
  }

  try {
    const response = await fetch(
      `${apiBaseUrl}/api/Payment/UpdateCandidatePaymentSuran`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payment),
      },
    );

    if (!response.ok) {
      throw new Error("Failed to update the candidate payment.");
    }
  } catch (error) {
    console.error("Error updating candidate payment:", error);
    throw error;
  }
};

export const getCandidatePayment = async (
  paymentID: number,
): Promise<CandidatePayment> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const orderResponse = await fetch(
    `${apiBaseUrl}/api/Payment/GetCandidatePayment/${paymentID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!orderResponse.ok) {
    throw new Error("Failed to fetch candidate payment");
  }

  const candidatePayment = await orderResponse.json();

  return candidatePayment;
};
